import React from "react";
import PropTypes from "prop-types";
import { Form, Field, FormSpy } from "react-final-form";

import {
  composeFormValidators,
  isRequired,
  isPhoneNumber,
} from "@lib/validations";

import InputText from "@components/Form/InputText";
import InputRadio from "@components/Form/Radio";
import Select from "@components/Form/Select";
import Heading from "@components/Heading";

const Condition = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);

const Westaco = ({ options, callback }) => {
  const WESTACO_TYPES = [
    {
      value: "DIRECT_RECHARGE",
      label: `Reincarcare directa`,
    },
    {
      value: "CASHUP_PINPRINTING",
      label: `Reincarcare Cod/Pin`,
    },
  ];

  if (!options) {
    return null;
  }

  const WESTACO_CONFIG = {};
  WESTACO_TYPES.forEach((type) => {
    WESTACO_CONFIG[type.value] = Object.keys(options)
      .map((okey) => {
        if (options[okey].category_type === type.value) {
          return options[okey];
        }
      })
      .filter((e) => !!e);
  });

  return (
    <div>
      <Form
        onSubmit={(values) => {
          this.props.handleAction(values, "payment");
        }}
        initialValues={{
          westaco_recharge:
            WESTACO_CONFIG[WESTACO_TYPES[0].value].length !== 0
              ? WESTACO_TYPES[0].value
              : WESTACO_TYPES[1].value,
        }}
        render={() => {
          return (
            <form>
              <FormSpy
                onChange={callback}
                subscription={{ values: true, errors: true }}
              />

              <Heading
                as="h2"
                display="h2"
                title={`Tip reincarcare`}
                border="bottom"
                classesProp="mb-3"
              />

              {WESTACO_CONFIG[WESTACO_TYPES[0].value].length !== 0 && (
                <>
                  <div className="pb-3">
                    <Field
                      name="westaco_recharge"
                      component={InputRadio}
                      label={WESTACO_TYPES[0].label}
                      type="radio"
                      value={WESTACO_TYPES[0].value}
                    />
                  </div>

                  <Condition
                    when="westaco_recharge"
                    is={WESTACO_TYPES[0].value}
                  >
                    <div className="pb-3">
                      <Field
                        name={`option_guid_${WESTACO_TYPES[0].value}`}
                        component={Select}
                        label={`Valoare reincarcare`}
                        required
                        validate={isRequired()}
                        defaultValue={
                          WESTACO_CONFIG[WESTACO_TYPES[0].value][0].guid
                        }
                      >
                        <option value="">{`Alege...`}</option>
                        {WESTACO_CONFIG[WESTACO_TYPES[0].value].map(
                          (option) => (
                            <option
                              key={WESTACO_TYPES[0].value + option.guid}
                              value={option.guid}
                              data-price={option.option_price}
                            >
                              {`${option.recharge_value}€ (${option.selling_price} ${option.fiscal_currency} ${option.name})`}
                            </option>
                          )
                        )}
                      </Field>
                    </div>

                    <div className="pb-3">
                      <Field
                        name="phone_number"
                        component={InputText}
                        label={`Numar de telefon`}
                        type="tel"
                        required
                        validate={composeFormValidators(
                          isRequired(),
                          isPhoneNumber()
                        )}
                      />
                    </div>
                  </Condition>
                </>
              )}

              {WESTACO_CONFIG[WESTACO_TYPES[1].value].length !== 0 && (
                <>
                  <div className="pb-3">
                    <Field
                      name="westaco_recharge"
                      component={InputRadio}
                      label={WESTACO_TYPES[1].label}
                      type="radio"
                      value={WESTACO_TYPES[1].value}
                    />
                  </div>

                  <Condition
                    when="westaco_recharge"
                    is={WESTACO_TYPES[1].value}
                  >
                    <div className="pb-3">
                      <Field
                        name={`option_guid_${WESTACO_TYPES[1].value}`}
                        component={Select}
                        label={`Valoare reincarcare`}
                        required
                        validate={isRequired()}
                      >
                        <option value="">{`Alege...`}</option>

                        {WESTACO_CONFIG[WESTACO_TYPES[1].value].map(
                          (option) => (
                            <option
                              key={WESTACO_TYPES[1].value + option.guid}
                              value={option.guid}
                              data-price={option.option_price}
                            >
                              {`${option.recharge_value}€ (${option.selling_price} ${option.fiscal_currency} ${option.name})`}
                            </option>
                          )
                        )}
                      </Field>
                    </div>

                    <div className="pb-3">
                      <small>
                        {`Codul de reincarcare va fi trimis pe mailul dumneavoastra, imediat dupa ce completati datele dumneavoastra personale.`}
                      </small>
                    </div>
                  </Condition>
                </>
              )}
            </form>
          );
        }}
      />
    </div>
  );
};

Westaco.propTypes = {
  guid: PropTypes.string,
};

Westaco.contextTypes = {
  config: PropTypes.object,
};

export default Westaco;
